var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VeeValidateValidationProvider',_vm._b({ref:"input",class:_vm.isRequired ? 'v-input-required' : '',scopedSlots:_vm._u([{key:"default",fn:function({ errors }){return [_vm._t("default",null,{"label":_vm.name,"errors":errors,"validate":_vm.validate})]}}],null,true)},'VeeValidateValidationProvider',_vm.validationProviderProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }